<div
  class="language-switcher notranslate"
  translate="no"
  (click)="$event.stopPropagation()"
  [ngClass]="{ 'language-logged-out': !authService?.isAuthenticated() }"
>
  <button
    type="button"
    class="language-switcher__toggle"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isDropdownOpen"
    [attr.aria-label]="labels.SELECT_LANGUAGE"
    [ngClass]="{
      'only-icon-logged-in':
        authService?.isAuthenticated() && !isEditMode
    }"
  >
    <em
      class="icon-liteglobe language-switcher__icon"
      [ngClass]="{
        'icon-liteglobe-authenticated':
          !authService?.isAuthenticated() || isEditMode
      }"
    ></em>
    <!-- <span class="language-switcher__label" *ngIf="!onlyIcon">
      {{ currentLanguageName }}
    </span> -->
    <!-- <em
      class="icon-litechevron_down language-switcher__icon-litechevron_down"
      *ngIf="!onlyIcon"
    ></em> -->
  </button>

  <div class="language-switcher__dropdown" *ngIf="isDropdownOpen">
    <div class="language-switcher__search">
      <input
        type="text"
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
        [placeholder]="labels.SEARCH_LANGUAGE"
        class="language-switcher__search-input"
        autocomplete="off"
      />
    </div>
    <ul class="language-switcher__list">
      <li
        *ngFor="let lang of filteredLanguages"
        class="language-switcher__item"
        [class.language-switcher__item--active]="lang.code === currentLocale"
        (click)="selectLanguage(lang.code)"
      >
        {{ lang.name }}
      </li>
      <li
        *ngIf="!filteredLanguages.length"
        class="language-switcher__no-results"
      >
        No results
      </li>
    </ul>
  </div>
</div>
